import { render, staticRenderFns } from "./WVTextarea.vue?vue&type=template&id=4bcf1c8c"
import script from "./WVTextarea.vue?vue&type=script&lang=js"
export * from "./WVTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports